import React, { useState } from 'react'
import { PropTypes } from 'prop-types'

import { IntegrationsGrid, GridFilters, FilterReset, AllButton } from './Grid.styles'
import IntegrationsContainer from '../Integration/IntegrationsContainer'
import FilterSwitch from './FilterSwitch'
import CardContainer from '../Card/Card'

export default function Integrations({ connectors, filterSet }) {
	const [checked, setChecked] = useState([])
	const [allFilters, setAllFilters] = useState(true)

	const newValueArr = []

	if (filterSet) {
		filterSet.map((filter) => {
			const acronym = filter.split(' ').length

			if (acronym === 1) {
				newValueArr.push({
					title: filter,
					value: filter.toLowerCase(),
				})
				return
			}

			const newValue = filter
				.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
					return index === 0 ? word.toLowerCase() : word.toUpperCase()
				})
				.replace(/\s+/g, '')

			return newValueArr.push({
				title: filter,
				value: newValue,
			})
		})
	}

	const resetCheckboxes = () => {
		const newChecked = []

		setChecked(newChecked)
		setAllFilters(true)
	}

	const handleChange = (value) => {
		const currentIndex = checked.indexOf(value)
		const newChecked = [...checked]

		if (currentIndex === -1) {
			newChecked.push(value)
		} else {
			newChecked.splice(currentIndex, 1)
		}

		if (newChecked.length === 0) {
			setAllFilters(true)
		} else {
			setAllFilters(false)
		}

		setChecked(newChecked)
	}

	function filterOnCategory(connector) {
		const { tool } = connector
		const connectorFilters = tool.categoryFilters

		if (checked.length === 0) {
			return connector
		}

		const found = connectorFilters.some((r) => checked.includes(r))

		if (found) {
			return connector
		}

		return null
	}

	const filters = newValueArr.map((f, i) => (
		<FilterSwitch
			key={`${i}_${f.title}`}
			filter={f}
			index={i}
			checkedArray={checked}
			handleChange={handleChange}
		/>
	))

	// TODO - query Sanity for better data instead of using _raw

	return (
		<>
			{filterSet ? (
				<GridFilters>
					{filters}
					<FilterReset>
						<AllButton
							type="button"
							onClick={resetCheckboxes}
							value="Reset All Filters"
							allFilters={allFilters}
						/>
					</FilterReset>
				</GridFilters>
			) : null}

			<IntegrationsGrid>
				{filterSet ? (
					<>
						{connectors
							.filter((connector) => filterOnCategory(connector))
							.map((connector) => (
								<IntegrationsContainer connector={connector} key={connector._key} />
							))}
					</>
				) : (
					<>
						{connectors.map((connector) => (
							<CardContainer connector={connector} key={connector._key} />
						))}
					</>
				)}
			</IntegrationsGrid>
		</>
	)
}

Integrations.propTypes = {
	connectors: PropTypes.array,
	filterSet: PropTypes.array,
}
